<div class="kt-chat">
  <div class="kt-portlet kt-portlet--head-lg kt-portlet--last">
    <div class="kt-portlet__body">
      <div class="kt-scroll kt-scroll--pull" id="messages">
        <div class="getting-records text-center" *ngIf="commentSvc.gettingRecords">
          <br />
          <h6 [translate]="'GENERAL.GETTING_RECORDS'" class="text-center">
            <i class="fas fa-spinner fa-spin"></i> Getting records...
          </h6>
          <br />
        </div>
        <div class="kt-chat__messages" *ngIf="commentSvc.record$ | async as record">
          <div
            class="kt-chat__message"
            *ngFor="let msg of record.data; let i = index"
            [ngClass]="{ 'kt-chat__message--right': msg.placement == 1 }"
          >
            <div class="kt-chat__user">
              <span class="kt-chat__datetime" *ngIf="msg.placement == 1">
                {{ msg.created_at | timeAgo }}</span
              >
              <a
                *ngIf="msg.client"
                href="javascript:;"
                class="kt-chat__username text-capitalize"
              >
                {{ msg.client.firstname + ' ' + msg.client.lastname }}</a
              >
              <a
                *ngIf="msg.admin && msg.placement == 0"
                href="javascript:;"
                class="kt-chat__username text-capitalize"
              >
                {{ msg.admin.firstname + ' ' + msg.admin.lastname }}</a
              >
              <a
                *ngIf="msg.placement == 1"
                href="javascript:;"
                class="kt-chat__username"
              >
                You</a
              >
              <span class="kt-chat__datetime" *ngIf="msg.placement == 0">
                {{ msg.created_at | timeAgo }}</span
              >
            </div>

            <div
              class="kt-chat__text"
              [ngClass]="{
                'kt-bg-light-brand': msg.placement == 1,
                'kt-bg-light-success': msg.placement == 0,
              }"
            >
              <div class="text" [innerHtml]="msg.comment | linkify"></div>
              <div class="files" *ngIf="msg.files && msg.files.length > 0">
                <span
                  class="badge badge-default"
                  *ngFor="let file of msg.files; let idx = index"
                >
                  <img
                    *ngIf="file.thumburl && file.thumburl.trim().length > 0"
                    class="mr-1"
                    src="{{ url + '/file?f=' + file.thumburl }}"
                    width="35"
                    alt=""
                  />
                  <a
                    href="{{ url + '/file?f=' + file.filename }}"
                    class="mr-1"
                    target="_blank"
                  >
                    {{ file.tmpname }}
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="kt-portlet__foot" *ngIf="authSvc.loginUser.prwx == 7">
      <cnc-comment-form [commentType]="commentType"></cnc-comment-form>
    </div>
  </div>
</div>
